import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {Button, Card, Icon, Input, Label, Loader, Message} from 'semantic-ui-react';
import {discoverSamples} from './api';

const Page = styled.div`
  padding: 20px;
  max-width: 1100px;
  margin: 0 auto;
`;

const Filters = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  align-items: center;
`;

const SampleChapterDiscover = () => {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);
  const [q, setQ] = useState('');
  const [hasAudioOnly, setHasAudioOnly] = useState(false);

  const load = async () => {
    setItems(null);
    try {
      const data = await discoverSamples({
        q: q || undefined,
        hasAudio: hasAudioOnly ? 'true' : undefined,
      });
      setItems(data);
    } catch (e) {
      setError(e.message);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page>
      <h1>
        <Icon name="book" /> Sample chapters
      </h1>
      <p>
        Read first chapters from indie authors and tell them whether you'd keep
        reading. Some samples have audio narration, others are text only.
      </p>
      <Filters>
        <Input
          placeholder="Search title, author or description"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && load()}
        />
        <Button
          basic={!hasAudioOnly}
          color={hasAudioOnly ? 'violet' : undefined}
          onClick={() => {
            setHasAudioOnly(!hasAudioOnly);
            setTimeout(load, 0);
          }}
        >
          <Icon name="volume up" /> Audio only
        </Button>
        <Button onClick={load}>
          <Icon name="search" /> Search
        </Button>
      </Filters>

      {error && <Message error content={error} />}
      {!items && <Loader active inline="centered" />}
      {items && items.length === 0 && <p>No sample chapters yet.</p>}

      <Card.Group itemsPerRow={3} stackable>
        {items &&
          items.map((s) => (
            <Card key={s._id} as={Link} to={`/sample-chapters/read/${s._id}`}>
              {s.coverUrl && <img alt="" src={s.coverUrl} />}
              <Card.Content>
                <Card.Header>{s.title}</Card.Header>
                <Card.Meta>
                  by {s.authorName || 'Unknown'}{' '}
                  <Label size="tiny">Variant {s.variantLabel}</Label>
                </Card.Meta>
                <Card.Description>{s.description}</Card.Description>
              </Card.Content>
              <Card.Content extra>
                <Label size="tiny">
                  <Icon name="font" /> Text
                </Label>
                {s.hasAudio ? (
                  <Label color="violet" size="tiny">
                    <Icon name="volume up" /> Audio
                  </Label>
                ) : (
                  <Label size="tiny" basic>
                    No audio
                  </Label>
                )}
                {s.wordCount ? (
                  <Label size="tiny" basic>
                    {s.wordCount} words
                  </Label>
                ) : null}
              </Card.Content>
            </Card>
          ))}
      </Card.Group>
    </Page>
  );
};

export default SampleChapterDiscover;
